<footer class="footer">
  <p>© 2025 ArcadeX. All rights reserved.</p>
</footer>
